import React from 'react'
import PropTypes from 'prop-types'
import Link from '../Link'
import { Snapshot } from '../Snapshot'
import { Processing } from '../Processing'
import { ITEM_CONTENT_ACTIONS } from 'shared/constants'
import isEqual from 'lodash/isEqual'
const HOSTNAMES_TO_IGNORE = ["salesconnect.cisco.com"]

class LinkContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isProcessing: true,
      requiresSnapshot: false
    }
  }

  componentDidMount() {
    this.handleNewItem()
  }

  componentDidUpdate(prevProps) {
    !isEqual(prevProps.item.id, this.props.item.id) && this.handleNewItem()
  }

  setSnapshotRequired = (secured) => {
    const itemHosname = new URL(this.props.item.link_url).hostname
    const requiresSnapshot = !HOSTNAMES_TO_IGNORE.includes(itemHosname) &&
      (this.props.requireSsl && !secured) &&
      !this.props.item.snapshot_disabled

    this.setState({
      requiresSnapshot,
      isProcessing: false
    })
  }

  handleNewItem = () => {
    this.setState({
      isProcessing: true,
      requiresSnapshot: false
    })

    if (this.props.item.secured == null) {
      this.props.onItemContentAction(
        ITEM_CONTENT_ACTIONS.analyzeUrl,
        { contentItemId: this.props.contentItemId }
      )
        .then(response => {
          this.setSnapshotRequired(response.data.secured)
        })
    }
    else {
      this.setSnapshotRequired(this.props.item.secured)
    }
  }

  render() {
    if(this.state.isProcessing) {
      return <Processing />
    }
    else {
      return this.state.requiresSnapshot ?
        <Snapshot
          item={this.props.item}
          contentItemId={this.props.contentItemId}
          onItemContentAction={this.props.onItemContentAction} /> :
        <Link item={this.props.item} />
    }
  }
}

LinkContainer.propTypes = {
  item: PropTypes.object.isRequired,
  contentItemId: PropTypes.number.isRequired,
  requireSsl: PropTypes.bool,
}

export default LinkContainer
